import { shuffle } from '../helpers.js';
import axios from 'axios';

export default {
  initApp(context, payload) {
    context.commit('initializeApp', payload);
  },
  loadCmsData(context) {
    fetch(`${window.cmsUrl}/wp-json/wp/v2/stations?slug=${window.cmsSlug}&lang=${context.state.lang}`)
        .then(data => data.json())
        .then(data => {
          return { ...data[0], levels: data[0].levels.map(level => {
            return { ...level, options: shuffle(level.options) }
          })};
        })
        .then(data => context.commit('loadCmsDataSuccess', data))
        .catch(err => context.commit('loadCmsDataFailed', err))
  },
  setcurrentLevelIndex(context, payload) {
    context.commit('updateCurrentLevelIndex', payload);
  },
  incrementTotalCorrectAnswers(context) {
    context.commit('updateTotalCorrectAnswers');
  },
  answeredCorrect(context) {
    context.commit('updateCorrectAswered');
  },
  answeredWrong(context) {
    context.commit('updateWrongAswered');
  },
  nextLevel(context) {
    context.commit('updateCurrentLevelIndex');
  },
  setGlobalPlayState(context, payload) {
    context.commit('updateGlobalPlayState', payload);
  },

  clickCount(context) {
    context.commit('updateClickCounter');
  },

  startStation(context) {
    context.commit('updateScreenState', 'quiz');
    context.commit('updateCurrentLevelIndex', 0);
    context.commit('updateStartTimestamp', Date.now());
  },
  exitStation(context) {
    context.commit('updateScreenState', 'end');
    context.commit('updateEndTimestamp', Date.now());
  },
  sendStatistics(context, payload) {
    context.commit('sendStatistics');
    axios
      .post(window.apiUrl + '/api/scores', {
        station_id: payload.station_id,
        visitor_id: payload.visitor_id,
        score: payload.score,
        duration: payload.duration,
        activity: payload.activity
      })
      .then(data => context.commit('sendStatisticsSuccess', data))
      .catch(err => context.commit('sendStatisticsFailed', err))
  },
};